import { hasRoles,ADMIN_ROLES } from "./roles";

export default function isAdmin(){
    return hasRoles(ADMIN_ROLES);
}
